import SearchHeader from 'components/app/controllers/Selectors/common/SearchHeader';
import { HeaderRenderProps } from 'components/core/controllers/Selector';
import React from 'react';
import { strings } from 'resources';

export function SprintHeader(props: HeaderRenderProps): JSX.Element {
  return <SearchHeader title={strings.sprintDropdown.select} {...props} />;
}
